import { createFileRoute } from "@tanstack/react-router";
import { MeetingPage } from "@/features/meetings/MeetingPage";

export const Route = createFileRoute("/_app/meetings/$meeting")({ component: Page });

function Page() {
  const { meeting } = Route.useParams();
  return <MeetingPage id={meeting} />;
}
